import {Injectable} from '@angular/core';
import {CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router} from '@angular/router';
import {Observable} from 'rxjs';
import {AuthService} from '../auth.service';
import {ToastrService} from 'ngx-toastr';
import {TranslateService} from '@ngx-translate/core';

@Injectable({
    providedIn: 'root'
})
export class OpenedSessionGuard implements CanActivate {

    private hashSession: string;

    constructor(private toastr: ToastrService,
                private router: Router,
                private authService: AuthService,
                private translate: TranslateService) {
        this.hashSession = this.authService.getHash();
    }

    canActivate(
        next: ActivatedRouteSnapshot,
        state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {

        const hash = next.paramMap.get('hash');
        if (hash !== this.hashSession &&
        ![hash, this.hashSession].includes(null) &&
        ![hash, this.hashSession].includes(undefined) &&
        ![hash, this.hashSession].includes('')) {
            const url = `app/login/pyf/${hash}`;
            const message: any = this.translate.instant('AppLockSession.header');
            this.toastr.error(message);
            this.router.navigateByUrl(url);
            return false;
        }
        return true;
    }
}
